import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import Navbar from "./Navbar";
import Showcase from "./Showcase";
import Info from "./Info";
import Order from "./Order";
import Orderprocess from "./Orderprocess";
import Payment from "./Payment";
import Location from "./Location";
import Footer from "./Footer";
// import Success from "./Success";
// import { Router } from "@reach/router";
// import Modal from "./Modal";
import "./App.css";
import fire from "../config/firebase";
// import Dashboard from "./Dashboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [show, setShow] = useState(false);
  const [user, setUser] = useState("");
  // const [modelIsOpen, setmodelIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [hasAccount, setHasAccount] = useState(false);
  const [err, setError] = useState("Enter your details");
  // const [errDiv, setErrorDiv] = useState("Entere your details");

  const closeModalHandler = () => setShow(false);

  // const checkClass = (e) => {
  //   if (e.target.className == "container" || "main-div") {
  //     closeModalHandler();
  //   }
  // };

  // const removeAlert = () => {
  //   setTimeout(function () {
  //     $(".alert").fadeOut(1500);
  //   }, 5000);
  // };

  toast.configure();
  const notify = () => {
    toast.dark("Hurry!! you are successfully logged in", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 6000,
    });
  };

  const notifyLogout = () => {
    toast.info("Logout successful", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 6000,
    });
  };

  const clearInputs = () => {
    setEmail("");
    setPassword("");
    // Modal.setEmail("");
    // Modal.setPassword("");
  };

  const handleLogin = () => {
    fire
      .auth()
      // .signInWithEmailAndPassword(Modal.email, Modal.password)
      .signInWithEmailAndPassword(email, password)

      .catch((err) => {
        setError(err.message);
      });
  };

  const handleSignup = () => {
    fire
      .auth()
      // .createUserWithEmailAndPassword(Modal.email, Modal.password)
      .createUserWithEmailAndPassword(email, password)
      .catch((err) => {
        setError(err.message);
      });
  };

  const handleLogout = () => {
    fire.auth().signOut();
    notifyLogout();
  };

  const authListener = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        clearInputs();
        setUser(user);
      } else {
        setUser("");
      }
    });
  };

  // const handleErrorDiv = () => {
  //   setTimeout(() => {
  //     setErrorDiv(err);
  //   }),
  //     2000;
  // };

  useEffect(() => {
    authListener();
    // const unsubscribe = authListener();
    // return () => {
    //   unsubscribe();
    // };
  }, []);

  // useEffect(() => {
  //   handleErrorDiv();
  // }, [err]);

  return (
    <div className="App">
      {user ? (
        <div>
          <header class="text-gray-500 bg-gray-900 body-font" onLoad={notify}>
            <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
              <a class="flex title-font font-medium items-center text-white mb-4 md:mb-0">
                <img class="logo" src="./logo.png" alt="" srcset="" />
                <span class="ml-3 text-xl">Satimata-Store</span>
              </a>
              <nav class="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-teal-700 flex flex-wrap items-center text-base justify-center">
                <h4>{user.email}</h4>
              </nav>
              <button
                onClick={handleLogout}
                class="btn-openModal signup-btn flex mx-auto text-white bg-indigo-500 border-0 py-1 px-3 focus:outline-none hover:bg-purple-600 rounded text-lg"
              >
                Logout
              </button>
              <span class="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start"></span>
            </div>
          </header>
          <div
            class="flex w-full h-screen items-center justify-center bg-grey-lighter"
            id="file-upload"
          >
            <label class="w-64 flex flex-col items-center px-4 py-6 bg-indigo-500 text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-purple-600 hover:text-white">
              <svg
                class="w-8 h-8"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
              </svg>
              <span class="mt-2 text-base leading-normal">Upload our list</span>
              <input type="file" class="hidden" />
            </label>
          </div>
          {/* <h1 class="sm:text-3xl text-2xl text-white font-medium title-font mb-2 md:w-2/5">
            DASHBOARD
          </h1>
          <p class="leading-relaxed text-grey">Hollla u are logged in </p>
          <button
            onClick={handleLogout}
            class="flex mx-auto text-white bg-indigo-500 border-0 py-1 px-3 focus:outline-none hover:bg-purple-600 rounded text-lg"
          >
            Logout
          </button> */}
        </div>
      ) : (
        // <Dashboard handleLogout={handleLogout} />
        <div>
          {/* {show ? (
            <Modal
              closeModalHandler={closeModalHandler}
              handleLogin={handleLogin}
              handleSignup={handleSignup}
              show={show}
            />
          ) : null} */}

          {show ? (
            <div
              class="main-div mx-auto flex-1 flex flex-col items-center justify-center"
              // onClick={checkClass}
            >
              <div class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2 my-5">
                <div class="bg-white px-6 py-8 rounded shadow-md text-black w-full for-closeBtn">
                  <span onClick={closeModalHandler} className="close-modal-btn">
                    x
                  </span>
                  {hasAccount ? (
                    <div>
                      <h1 class="mb-8 text-3xl text-center">Sign in</h1>
                    </div>
                  ) : (
                    <div>
                      <h1 class="mb-8 text-3xl text-center">Sign up</h1>
                    </div>
                  )}
                  <div>
                    <div class="alert flex flex-row items-center bg-green-200 m-2 p-2 rounded border-b-2 border-green-300">
                      <div class="alert-content ml-4">
                        <div class="alert-description text-sm text-green-600">
                          {err}
                        </div>
                      </div>
                    </div>
                  </div>
                  <input
                    type="text"
                    class="block border border-grey-light w-full p-3 rounded mb-4"
                    autoFocus
                    required
                    name="email"
                    value={email}
                    placeholder="Email"
                    // onChange={(e) => Modal.setEmail(e.target.value)}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  <input
                    type="password"
                    class="block border border-grey-light w-full p-3 rounded mb-4"
                    name="password"
                    required
                    placeholder="Password"
                    value={password}
                    // onChange={(e) => Modal.setPassword(e.target.value)}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="btn-container">
                    {hasAccount ? (
                      <>
                        <button
                          onClick={handleLogin}
                          class="flex mx-auto text-white bg-indigo-500 border-0 py-1 px-3 focus:outline-none hover:bg-purple-600 rounded text-lg"
                        >
                          Sign in
                        </button>

                        <div class="text-grey-dark mt-6 haveAcc-div">
                          Don't have an account?{"  "}
                          <a
                            onClick={() => setHasAccount(!hasAccount)}
                            class="no-underline border-b border-blue"
                          >
                            Sign up
                          </a>
                        </div>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={handleSignup}
                          class="flex mx-auto text-white bg-indigo-500 border-0 py-1 px-3 focus:outline-none hover:bg-purple-600 rounded text-lg"
                        >
                          Sign up
                        </button>

                        <div class="text-grey-dark mt-6 haveAcc-div">
                          Already have an account?{"  "}
                          <a
                            onClick={() => {
                              setHasAccount(!hasAccount);
                            }}
                            class="no-underline border-b border-blue"
                          >
                            Sign in
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <header class="text-gray-500 bg-gray-900 body-font">
            <div class="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
              <a class="flex title-font font-medium items-center text-white mb-4 md:mb-0">
                <img class="logo" src="./logo.png" alt="" srcset="" />
                <span class="ml-3 text-xl">Satimata-Store</span>
              </a>
              <nav class="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-teal-700 flex flex-wrap items-center text-base justify-center">
                <h2 class="text-2xl text-white font-medium title-font mb-2">
                  We Believe in Quality &nbsp;
                  <span class="text-2xl text-purple-400 font-medium title-font mb-2">
                    Since: 1980
                  </span>
                </h2>
              </nav>
              <button
                onClick={() => setShow(true)}
                class="btn-openModal signup-btn flex mx-auto text-white bg-indigo-500 border-0 py-1 px-3 focus:outline-none hover:bg-purple-600 rounded text-lg"
              >
                Login
              </button>
              <span class="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start"></span>
            </div>
          </header>
          <Showcase />
          <Info />
          <Order />
          <Orderprocess />
          <Payment />
          <Location />
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
